import { render, staticRenderFns } from "./molecule.trayNavigationMenu.AddYourImageGallery.vue?vue&type=template&id=4e93486b"
import script from "./molecule.trayNavigationMenu.AddYourImageGallery.vue?vue&type=script&lang=ts"
export * from "./molecule.trayNavigationMenu.AddYourImageGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports